import type { ReactElement, ReactNode } from "react";
import { useState } from "react";
import useEffectOnce from "~/kernel/effects/useEffectOnce";

type RenderInBrowserProps = {
  children: ReactNode;
  fallback?: ReactElement | string;
};

export default function RenderInBrowser({
  children,
  fallback,
}: RenderInBrowserProps) {
  const [shouldRender, setShouldRender] = useState(false);

  useEffectOnce(() => {
    setShouldRender(true);
  });

  if (shouldRender) {
    return <>{children}</>;
  }

  return <>{fallback}</> ?? null;
}
